<template>
  <div class="not-found-container">
    <div class="background-layer" aria-hidden="true">
      <div class="background-orb"></div>
    </div>
    <div class="content-wrapper">
      <!-- Анимированная иллюстрация 404 -->
      <div class="illustration">
        <div class="number-404">
          <span class="digit digit-4-left">4</span>
          <span class="digit digit-0">
            <svg viewBox="0 0 200 200" class="magnifying-glass">
              <circle cx="80" cy="80" r="60" class="glass-circle" />
              <line x1="125" y1="125" x2="180" y2="180" class="glass-handle" />
              <circle cx="80" cy="80" r="45" class="glass-inner" />
            </svg>
          </span>
          <span class="digit digit-4-right">4</span>
        </div>
        
        <!-- Плавающие элементы -->
        <div class="floating-elements">
          <div class="floating-dot" style="--delay: 0s; --x: -20px; --y: -30px;"></div>
          <div class="floating-dot" style="--delay: 0.5s; --x: 40px; --y: -20px;"></div>
          <div class="floating-dot" style="--delay: 1s; --x: -30px; --y: 20px;"></div>
          <div class="floating-dot" style="--delay: 1.5s; --x: 50px; --y: 30px;"></div>
        </div>
      </div>

      <!-- Текстовый контент -->
      <div class="text-content">
        <h1 class="title">Страница не найдена</h1>
        <p class="description">
          Кажется, вы заблудились. Страница, которую вы ищете, не существует или была перемещена.
        </p>
      </div>

      <!-- Действия -->
      <div class="actions">
        <button @click="goHome" class="btn btn-primary">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="9 22 9 12 15 12 15 22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          На главную
        </button>
        <button @click="goBack" class="btn btn-secondary">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <line x1="19" y1="12" x2="5" y2="12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="12 19 5 12 12 5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Назад
        </button>
      </div>

      <!-- Популярные ссылки -->
      <!-- <div class="quick-links">
        <p class="quick-links-title">Может быть, вы искали:</p>
        <div class="links-grid">
          <router-link to="/search-courses" class="quick-link">
            <svg class="link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <circle cx="11" cy="11" r="8" stroke-width="2"/>
              <path d="M21 21l-4.35-4.35" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Поиск курсов
          </router-link>
          <router-link to="/student-dashboard" class="quick-link">
            <svg class="link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
              <line x1="9" y1="3" x2="9" y2="21" stroke-width="2"/>
            </svg>
            Панель студента
          </router-link>
          <router-link to="/video-lessons" class="quick-link">
            <svg class="link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <polygon points="5 3 19 12 5 21 5 3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Видео уроки
          </router-link>
          <router-link to="/articles-page" class="quick-link">
            <svg class="link-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2"/>
              <polyline points="14 2 14 8 20 8" stroke-width="2"/>
              <line x1="16" y1="13" x2="8" y2="13" stroke-width="2"/>
              <line x1="16" y1="17" x2="8" y2="17" stroke-width="2"/>
              <line x1="10" y1="9" x2="8" y2="9" stroke-width="2"/>
            </svg>
            Статьи
          </router-link>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Not404Found',
  mounted() {
    document.documentElement.classList.add('not-found-page')
    document.body.classList.add('not-found-page')
    const app = document.getElementById('app')
    if (app) app.classList.add('not-found-page')
  },
  beforeUnmount() {
    document.documentElement.classList.remove('not-found-page')
    document.body.classList.remove('not-found-page')
    const app = document.getElementById('app')
    if (app) app.classList.remove('not-found-page')
  },
  methods: {
    goHome() {
      this.$router.push('/')
    },
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.not-found-container {
  --accent-main: #0096ed;
  --accent-dark: #007dca;
  --accent-light: #49b8ff;
  --accent-soft: #dff2ff;
  min-height: 100vh;
  min-height: 100svh;
  min-height: 100dvh;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--accent-main) 0%, var(--accent-dark) 100%);
  padding: 2rem;
  position: relative;
  overflow: hidden;
  isolation: isolate;
}

:global(html.not-found-page),
:global(body.not-found-page),
:global(#app.not-found-page) {
  height: 100%;
  min-height: 100%;
  background: linear-gradient(135deg, #0096ed 0%, #007dca 100%);
  overflow: hidden;
}

.not-found-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  animation: rotate 30s linear infinite;
  pointer-events: none;
}

.background-layer {
  display: none;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.content-wrapper {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  width: 100%;
}

/* Иллюстрация 404 */
.illustration {
  position: relative;
  margin-bottom: 3rem;
}

.number-404 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: 8rem;
  font-weight: 800;
  color: white;
  text-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.digit {
  display: inline-block;
  animation: bounce 2s ease-in-out infinite;
}

.digit-4-left {
  animation-delay: 0s;
}

.digit-0 {
  animation-delay: 0.2s;
}

.digit-4-right {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.magnifying-glass {
  width: 120px;
  height: 120px;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.2));
}

.glass-circle {
  fill: none;
  stroke: white;
  stroke-width: 6;
}

.glass-handle {
  stroke: white;
  stroke-width: 8;
  stroke-linecap: round;
}

.glass-inner {
  fill: rgba(255, 255, 255, 0.1);
  stroke: rgba(255, 255, 255, 0.3);
  stroke-width: 2;
}

/* Плавающие элементы */
.floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.floating-dot {
  position: absolute;
  width: 12px;
  height: 12px;
  background: white;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  opacity: 0.6;
  animation: float 3s ease-in-out infinite;
  animation-delay: var(--delay);
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0);
    opacity: 0.6;
  }
  50% {
    transform: translate(var(--x), var(--y));
    opacity: 0.2;
  }
}

/* Текстовый контент */
.text-content {
  margin-bottom: 2.5rem;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  color: white;
  margin: 0 0 1rem 0;
  text-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.description {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin: 0;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

/* Кнопки действий */
.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 3rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 1.75rem;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.btn:active {
  transform: translateY(0);
}

.btn-primary {
  background: var(--accent-soft);
  color: var(--accent-dark);
}

.btn-primary:hover {
  background: #ffffff;
}

.btn-secondary {
  background: rgba(223, 242, 255, 0.2);
  color: white;
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(223, 242, 255, 0.3);
}

.icon {
  width: 20px;
  height: 20px;
}

/* Быстрые ссылки */
.quick-links {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.quick-links-title {
  color: white;
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 1.5rem 0;
}

.links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
}

.quick-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: white;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.875rem;
  font-weight: 500;
}

.quick-link:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
}

.link-icon {
  width: 32px;
  height: 32px;
  stroke-width: 2;
}

/* Адаптивность */
@media (min-width: 1601px) and (max-width: 1800px),
       (min-width: 1367px) and (max-width: 1600px),
       (min-width: 769px) and (max-width: 1366px) {
  .background-layer {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
    background: linear-gradient(135deg, #0096ed 0%, #007dca 100%);
  }

  .background-orb {
    position: absolute;
    width: 220vmax;
    height: 220vmax;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(2);
    background: radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.11) 0%, transparent 52%);
    animation: rotate 30s linear infinite;
  }

  .not-found-container {
    background: transparent;
    width: 100%;
    height: 100vh;
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: visible;
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .not-found-container::before {
    display: none;
  }

  .content-wrapper {
    transform: translateY(-7vh) scale(2);
    transform-origin: center top;
    margin: 0 auto;
  }

  .illustration {
    margin-bottom: 1.5rem;
  }

  .text-content {
    margin-bottom: 1.25rem;
  }

  .actions {
    margin-bottom: 0;
  }
}

@media (min-width: 1601px) and (max-width: 1800px) {
  .not-found-container {
    padding: 2.5rem 3rem;
  }

  .content-wrapper {
    max-width: 760px;
  }

  .number-404 {
    font-size: clamp(6.8rem, 8.5vw, 7.8rem);
  }

  .title {
    font-size: clamp(2.3rem, 3vw, 2.6rem);
  }

  .magnifying-glass {
    width: 110px;
    height: 110px;
  }
}

@media (min-width: 1367px) and (max-width: 1600px) {
  .not-found-container {
    padding: 2.25rem;
  }

  .content-wrapper {
    max-width: 680px;
  }

  .number-404 {
    font-size: clamp(6rem, 7.2vw, 6.9rem);
  }

  .title {
    font-size: clamp(2rem, 2.9vw, 2.35rem);
  }
}

@media (min-width: 769px) and (max-width: 1366px) {
  .not-found-container {
    padding: 2rem 1.5rem;
  }

  .content-wrapper {
    max-width: 620px;
  }

  .illustration {
    margin-bottom: 2.25rem;
  }

  .number-404 {
    font-size: clamp(4.2rem, 7vw, 5.4rem);
    gap: 0.75rem;
  }

  .magnifying-glass {
    width: 96px;
    height: 96px;
  }

  .title {
    font-size: clamp(1.65rem, 3.1vw, 2.05rem);
  }

  .description {
    font-size: 1rem;
  }

  .btn {
    padding: 0.75rem 1.5rem;
  }
}

@media (max-width: 768px) {
  .number-404 {
    font-size: 5rem;
    gap: 0.5rem;
  }

  .magnifying-glass {
    width: 80px;
    height: 80px;
  }

  .title {
    font-size: 2rem;
  }

  .description {
    font-size: 1rem;
  }

  .actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
    justify-content: center;
  }

  .links-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .not-found-container {
    padding: 1rem;
  }

  .number-404 {
    font-size: 4rem;
  }

  .magnifying-glass {
    width: 60px;
    height: 60px;
  }

  .quick-links {
    padding: 1.5rem;
  }

  .links-grid {
    grid-template-columns: 1fr;
  }
}
</style>
